import {
  LayoutDashboard,
  Building2,
  File,
  FileDiff,
  Megaphone,
  RouteIcon,
  Map,
  Bus,
  Settings2,
  Upload,
} from 'lucide-react';

import { ILinkAuth, useAuthorizationLinks } from '@/utils/linkAuth';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

import { tenantSettingsSidebarItems } from './tenantSettings';

export const tenantSidebarItems: ILinkAuth[] = [
  {
    label: 'Dashboard',
    to: '/',
    icon: LayoutDashboard,
  },
  {
    label: 'Empresas',
    to: '/companies',
    icon: Building2,
    authorization: ({ can }) => can('list', 'companies'),
  },
  {
    label: 'Documentos',
    to: '/documents',
    icon: File,
    authorization: ({ can }) => can('list', 'documents'),
    items: [
      {
        label: 'Solicitações de Alteração',
        to: '/document-requests',
        icon: FileDiff,
        authorization: ({ can }) => can('list', 'document_requests'),
      },
    ],
  },

  {
    label: 'Rotas',
    to: '/buslines',
    icon: RouteIcon,
    authorization: ({ can }) => can('list', 'buslines'),
    items: [
      {
        label: 'Importação de Rotas',
        to: '/buslines/imports',
        icon: Upload,
        authorization: ({ can }) => can('update', 'buslines'),
      },
    ],
  },
  {
    label: 'Linhas e Horários',
    to: '/busline-schedules',
    icon: Bus,
    authorization: ({ can }) => can('list', 'buslines'),
  },
  {
    label: 'Execuções de Rotas',
    to: '/actings',
    icon: Map,
    authorization: ({ can }) => can('list', 'actings'),
  },
  {
    label: 'Frotas',
    to: '/fleets',
    icon: Bus,
    authorization: ({ can }) => can('list', 'fleets'),
  },
  {
    label: 'NPS',
    to: '/nps',
    icon: Megaphone,
    authorization: ({ can }) => can('list', 'nps'),
  },
  {
    label: 'Configurações',
    to: '/settings',
    icon: Settings2,
    authorization: (ability) =>
      tenantSettingsSidebarItems.some((item) => item.authorization?.(ability)),
  },
];

export const companySidebarItems: ILinkAuth[] = [
  { label: 'Dashboard', to: '/', icon: LayoutDashboard },
  {
    label: 'Documentos',
    to: '/documents',
    icon: File,
    authorization: ({ can }) => can('list', 'documents'),
    items: [
      {
        label: 'Solicitações de Alteração',
        to: '/my-document-requests',
        icon: FileDiff,
        authorization: ({ can }) => can('list', 'document_requests'),
      },
    ],
  },
  {
    label: 'Linhas e Horários',
    to: '/busline-schedules',
    icon: Bus,
  },
  {
    label: 'Relatórios NPS',
    to: '/nps-reports',
    icon: Megaphone,
    authorization: ({ can }) => can('list', 'nps'),
  },
  {
    label: 'Empresa',
    to: '/company',
    icon: Building2,
    authorization: ({ can }) => can('viewDetails', 'company'),
  },
];

export const useSessionSidebarItems = () => {
  const session = useAuthSessionStore(({ session }) => session);

  const links = useAuthorizationLinks(
    session?.organization?.company ? companySidebarItems : tenantSidebarItems,
  );

  return links;
};
